import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SessionService } from 'src/app/core/services/session.service';
import { AbstractView } from 'src/app/core/abstract_view';
import { AppMainComponent } from '../main/app.main.component';

@Component({
    selector: 'app-sidebar',
    templateUrl: './app.sidebar.component.html',
    styleUrls: ['./app.sidebar.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class AppSideBarComponent extends AbstractView implements OnInit {
    optionsEstablishments = false;
    optionsPrices = false;
    optionsUsers = false;
    optionsSuggested = false;
    optionsQuotations = false;
    optionsConfiguration = false;
    optionsReportsMp = false;
    optionsProduct = false;
    optionsCompensations = false;
    optionsPricingPdv = false;
    optionsPromotionalProducts = false;
    optionsClients = false;
    optionsKpi = false;

    constructor(
        public app: AppMainComponent,
        private messageService: MessageService,
        public router: Router,
        private confirmationService: ConfirmationService,
        private sessionService: SessionService
    ) {
        super(messageService, router);
    }

    onLogout(event: Event): void {
        event.preventDefault();
        this.confirmationService.confirm({
            header: 'Cerrar sesión',
            icon: 'pi pi-sign-out',
            message: '¿Desea salir del sistema?',
            acceptLabel: 'Salir',
            rejectLabel: 'Cancelar',
            accept: () => this.sessionService.logout()
        });
    }

    ngOnInit(): void {
        if (
            this.getAuth(['MANAGE_SUGGESTED']) ||
            this.getAuth(['PARAMETERS']) ||
            this.getAuth(['SETTINGS']) ||
            this.getAuth(['MANAGE_ASSIGMENT']) ||
            this.getAuth(['MANAGE_NEW_PRODUCTS']) ||
            this.getAuth(['MANAGE_RESTRICTIONS']) ||
            this.getAuth(['MANAGE_REPORTS'])
        ) {
            this.optionsSuggested = true;
        }
        if (this.getAuth(['MANAGE_USERS']) || this.getAuth(['MANAGE_EXTERNAL_USERS'])) {
            this.optionsUsers = true;
        }
        if (this.getAuth(['MANAGE_ESTABLISHMENTS'])) {
            this.optionsEstablishments = true;
        }
        if (
            this.getAuth(['MANAGE_PRICES']) ||
            this.getAuth(['MANAGE_PRICES_DEALER'])
        ) {
            this.optionsPrices = true;
        }
        if (this.getAuth(['MANAGE_QUOTES'])) {
            this.optionsQuotations = true;
        }
        if (this.getAuth(['MANAGE_BANKS']) || this.getAuth(['MANAGE_CLOSE_CASH'])) {
            this.optionsConfiguration = true;
        }
        if (
            this.getAuth(['MANAGE_REPORT_PDV']) ||
            this.getAuth(['MANAGE_REPORT_TREASURER']) ||
            this.getAuth(['MANAGE_REPORT_ACCOUNT']) ||
            this.getAuth(['MANAGE_REPORT_COMMISSION']) ||
            this.getAuth(['MANAGE_REPORT_CLOSE_CASH']) ||
            this.getAuth(['MANAGE_REPORT_PDV_COMPLAINS'])
        ) {
            this.optionsReportsMp = true;
        }

        if (this.getAuth(['MANAGE_CATALOG_PRODUCTS'])) {
            this.optionsProduct = true;
        }
        if (this.getAuth(['MANAGE_ESTABLISHMENTS'])) {
            this.optionsCompensations = true;
        }
        if (this.getAuth(['MANAGE_PRICES_PDV']) || this.getAuth(['VIEW_SEARCH_PRICES_PDV'])) {
            this.optionsPricingPdv = true;
        }
        if (this.getAuth(['MANAGE_PRMOTIONALS_PEDIDOS'])) {
            this.optionsPromotionalProducts = true;
        }
        if (this.getAuth(['MANAGE_CLIENTS_PEDIDOS'])) {
            this.optionsClients = true;
        }
        if (this.getAuth(['VIEW_MANAGE_KPI'])) {
            this.optionsKpi = true;
        }
    }

}
